import { render, staticRenderFns } from "./appMultiselect.vue?vue&type=template&id=ec39bb2e&"
import script from "./appMultiselect.vue?vue&type=script&lang=js&"
export * from "./appMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports